import { createTheme } from '@mui/material';
import { red } from '@mui/material/colors';
import { deDE as coreDeDE } from '@mui/material/locale';
import { deDE as gridDeDE } from '@mui/x-data-grid-premium/locales';
import { deDE as pickersDeDE } from '@mui/x-date-pickers/locales';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: '#007acc',
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontSize: 12,
    },

    components: {
        MuiButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFilledInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormControl: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFormHelperText: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputBase: {
            defaultProps: {
                margin: 'dense',
                size: 'small',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiListItem: {
            defaultProps: {
                dense: true,
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTextField: {
            defaultProps: {
                margin: 'dense',
                fullWidth: true,
                variant: 'standard',
            },
        },
        MuiToolbar: {
            defaultProps: {
                variant: 'dense',
            },
        },
        MuiContainer: {
            defaultProps: {
                disableGutters: true,
            }
        }
    },
},
    gridDeDE,
    pickersDeDE,
    coreDeDE
);

export default theme;
